import { getUserMenus, getApplicationInfo } from "@/api/user";
import {
  setDocumentTitle,
  filterRouterCustomField,
  getCustomField,
} from "@/utils/util";
import { VUE_APP_IMG_URL, LOGIN_CLIENT_ID } from "@/config/env";
// import { LOGIN_CLIENT_ID } from '@/config/application'
// 给menus增加路径
function transformPath(item) {
  const currentPath = item.position;
  // item.filterRouterCustomField = filterRouterCustomField(item.customField)
  item.filterRouterCustomField = getCustomField(item);
  if (item.children) {
    for (let i = 0; i < item.children.length; i++) {
      const el = item.children[i];
      // el.filterRouterCustomField = filterRouterCustomField(el.customField)
      el.filterRouterCustomField = getCustomField(i);
      el.position = [...currentPath, "children", i];
      transformPath(el);
    }
  }
}

// 给Router增加路径
function transformRouterPath(item) {
  const currentPath = item.meta.position;
  if (item.children) {
    for (let i = 0; i < item.children.length; i++) {
      const el = item.children[i];
      el.meta.position = [...currentPath, "children", i];
      transformRouterPath(el);
    }
  }
}

function addPosition(originRoutes) {
  for (let i = 0; i < originRoutes.length; i++) {
    const el = originRoutes[i];
    el.position = [i];
    transformPath(el);
  }
}

const application = {
  state: {
    inner: {
      width: 0,
      height: 0,
    },
    title: "",
    showMenu: true,
    originRoutes: [],
    usedRouter: [],
    info: {},
    menuId: "",
    applicationId: LOGIN_CLIENT_ID,
  },

  mutations: {
    UPDATE_INNER(state, { width, height }) {
      state.inner = { width, height };
    },
    SET_APPTITLE(state, title) {
      setDocumentTitle(`${state.info.shortName}-${title}`);
      state.title = title;
    },
    UPDATE_ROUTES(state, routes) {
      state.originRoutes = routes;
    },
    mergeRoutes(state, mapRoutes) {
      for (let i = 0; i < mapRoutes.length; i++) {
        const el = mapRoutes[i];
        el.meta.position = [i];
        transformRouterPath(el, true);
      }
      state.usedRouter = mapRoutes;
    },
    SET_INFO(state, info) {
      document.querySelector("[rel=icon]").href = info.icon;
      state.info = info;
    },
    SET_MENU_ID(state, menuId) {
      state.menuId = menuId;
    },
  },

  actions: {
    // 获取原始菜单
    async getAsyncOriginRoutes({ commit, getters }) {
      const response = await getUserMenus(getters.userInfo.userId);
      addPosition(response.data.data);
      commit("UPDATE_ROUTES", response.data.data);
    },
    // 应用的宽高度
    async setInner({ commit }, { width, height }) {
      if (width && height) {
        await commit("UPDATE_INNER", { width, height });
      }
    },
    // 设置应用标题
    async setAppTitle({ commit }, title) {
      if (title === "" || title === undefined || title === null) return;
      await commit("SET_APPTITLE", title);
    },
    // 获取应用信息
    async setApplicationInfo({ commit }) {
      try {
        const { data } = await getApplicationInfo();
        Object.assign(data.data, {
          ...data.data,
          logo: `${VUE_APP_IMG_URL}${data.data.logo}`,
          icon: `${VUE_APP_IMG_URL}${data.data.icon}`,
        });
        commit("SET_INFO", data.data);
      } catch (error) {
        console.log(error);
      }
    },
    // 设置菜单id
    setCurrentMenuId({ commit }, menuId) {
      commit("SET_MENU_ID", menuId);
    },
  },
};

export default application;
